import { BooleanInput, coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface MapContainerComponentState {
    shouldShowActiveRestrictionsLayer: boolean;
    isZoneVisible: boolean;
}

@Component({
    selector: "dss-shared-lib-map-container",
    templateUrl: "./map-container.component.html",
    styleUrls: ["./map-container.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class MapContainerComponent {
    protected readonly shouldShowActiveRestrictionsLayer$ = this.localStore.selectByKey("shouldShowActiveRestrictionsLayer");
    protected readonly isZoneVisible$ = this.localStore.selectByKey("isZoneVisible");

    @Input()
    public set shouldShowActiveRestrictionsLayer(value: BooleanInput) {
        this.localStore.patchState({ shouldShowActiveRestrictionsLayer: coerceBooleanProperty(value) });
    }

    @Input()
    public set isZoneVisible(value: BooleanInput) {
        this.localStore.patchState({ isZoneVisible: coerceBooleanProperty(value) });
    }

    @Output() protected readonly pointLimitReached = new EventEmitter<number>();

    constructor(private readonly localStore: LocalComponentStore<MapContainerComponentState>) {
        localStore.setState({
            shouldShowActiveRestrictionsLayer: false,
            isZoneVisible: true,
        });
    }
}
